export default __webpack_public_path__ + "static/logo_client_toyota@2x-b5a01446f3426f256402c83baaa3797b.png";